import { useAuth } from '@clerk/clerk-react'
import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'

import { AuthLayout } from '@/components/auth/AuthLayout'
import { DigestFields } from '@/components/digest/DigestFields'
import { Button } from '@/components/ui/Button'
import { useMe } from '@/context/MeProvider'
import { ApiError } from '@/lib/api/client'
import { updateMyPreferences } from '@/lib/api/me'
import { takeAuthRedirect } from '@/lib/redirect'

export function WelcomePage() {
  const { isLoaded, isSignedIn, getToken } = useAuth()
  const { refresh } = useMe()
  const navigate = useNavigate()

  const [optIn, setOptIn] = useState(false)
  const [categories, setCategories] = useState<string[]>([])
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  if (!isLoaded) {
    return null
  }
  if (!isSignedIn) {
    return <Navigate to="/" replace />
  }

  function leave() {
    navigate(takeAuthRedirect(), { replace: true })
  }

  async function handleContinue() {
    setSaving(true)
    setError(null)
    try {
      await updateMyPreferences(
        { digestOptIn: optIn, digestCategories: optIn ? categories : [] },
        getToken,
      )
      await refresh()
      leave()
    } catch (err) {
      setError(
        err instanceof ApiError ? err.detail : "Couldn't save that just now.",
      )
      setSaving(false)
    }
  }

  return (
    <AuthLayout title="You're in">
      <div className="space-y-8">
        <p className="font-body text-body-md text-fg-muted text-center">
          One quick thing before you go.
        </p>

        <DigestFields
          optIn={optIn}
          categories={categories}
          onOptInChange={setOptIn}
          onCategoriesChange={setCategories}
          disabled={saving}
        />

        {error && (
          <p className="font-body text-body-sm text-error" role="alert">
            {error}
          </p>
        )}

        <div className="flex flex-col gap-3">
          <Button
            type="button"
            variant="gradient"
            size="lg"
            disabled={saving}
            onClick={() => void handleContinue()}
          >
            {saving ? 'Saving…' : 'Continue'}
          </Button>
          {error && (
            <Button type="button" variant="ghost" size="md" onClick={leave}>
              Continue without saving
            </Button>
          )}
        </div>
      </div>
    </AuthLayout>
  )
}
